import { Box, Typography } from '@mui/material';
import { useColors } from '../context/ThemeContext';

export default function AuthCard({ title, children }) {
  const colors = useColors();
  return (
    <Box sx={{
      // Subtracts the navbar height so it doesn't overflow the viewport
      // (MUI Toolbar: 56px on xs, 64px on sm+).
      minHeight: { xs: 'calc(100vh - 56px)', sm: 'calc(100vh - 64px)' },
      bgcolor: colors.bgDefault,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      px: 2, py: 2,
    }}>
      <Box sx={{
        width: '100%', maxWidth: 400,
        bgcolor: colors.bgPaper,
        borderRadius: 3, p: { xs: 3, sm: 5 },
        border: `1px solid ${colors.border}`,
        boxShadow: colors.shadowLg,
        display: 'flex', flexDirection: 'column', gap: 3,
      }}>
        <Box sx={{ textAlign: 'center', mb: 1 }}>
          <Typography variant="h4" sx={{
            background: colors.gradientBrand,
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            fontWeight: 800, letterSpacing: '-0.5px',
          }}>
            Publy Music
          </Typography>
          <Typography variant="body2" sx={{ color: colors.textSecondary, mt: 0.5 }}>
            {title}
          </Typography>
        </Box>
        {children}
      </Box>
    </Box>
  );
}
